import bg_1 from "@/components/SectorHexagons/bg_1.webp";
import bg_2 from "@/components/SectorHexagons/bg_2.webp";
import useTeam from "@/hooks/useTeam";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { TeamMemberCard } from "@/ui/TeamMemberCard";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className = "py-5 py-md-6", theme = "light" }) {
  const team = useTeam();

  return (
    <div className={cn(className, classes.TeamFeed)} data-bs-theme={theme}>
      <ParallaxBackground anim="y1:x2n:z0" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y2:x2:z0" image={bg_2} className={classes.bg_2} />
      <Container fluid="md">
        <Row>
          {team.map((member, index) => (
            <Col key={index} xs={12} md={3} className="px-0">
              <TeamMemberCard {...member} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
